export const CONSENT_KEY = "cookie_consent_v1";
export const ANONYMOUS_ID_KEY = "cookie_anonymous_id";

export const defaultConsent = {
  necessary: true,
  analytics: false,
  marketing: false,
  preferences: false,
  version: "v1",
};

export const getAnonymousId = () => {
  let anonymousId = localStorage.getItem(ANONYMOUS_ID_KEY);

  if (!anonymousId) {
    anonymousId = crypto.randomUUID();
    localStorage.setItem(ANONYMOUS_ID_KEY, anonymousId);
  }

  return anonymousId;
};

export const getCookieConsent = () => {
  try {
    const saved = localStorage.getItem(CONSENT_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
};

export const saveCookieConsent = (consent) => {
  const finalConsent = {
    ...defaultConsent,
    ...consent,
    necessary: true,
    anonymous_id: getAnonymousId(),
    givenAt: new Date().toISOString(),
  };

  localStorage.setItem(CONSENT_KEY, JSON.stringify(finalConsent));
  return finalConsent;
};

export const hasAnalyticsConsent = () => {
  return getCookieConsent()?.analytics === true;
};

export const hasMarketingConsent = () => {
  return getCookieConsent()?.marketing === true;
};